import React from 'react';
import Colors from 'enums/Colors';
import styled from 'styled-components';
import ImgCapa from '../assets/img_capa_book.svg';
import StyledGlobal from '../Alfabetizacao360NewDetail.styled';
import { RiShareBoxLine } from 'react-icons/ri';
import ImgDown from '../assets/img_down.svg';
import ImgReguaHorizontal from '../assets/img_regua_horintal_guarana_nova.png';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { useHistory } from 'react-router-dom';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-top: 60px;
        padding-left: 280px;

        @media screen and (max-width: 1600px) {
            padding-left: 80px;
        }
        @media screen and (max-width: 500px) {
            padding-left: 20px;
        }
    `,

    Tag: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        max-width: 520px;
        color: ${Colors.Blue};
    `,

    Row: styled.div`
        display: flex;
        gap: 120px;

        @media screen and (max-width: 1230px) {
            flex-direction: column;
            gap: 20px;
        }
    `,

    RowButtons: styled.div`
        display: flex;
        gap: 1rem;

        @media screen and (max-width: 420px) {
            flex-direction: column;
        }
    `,

    Column: styled.div`
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 600px;
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 32px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        color: ${Colors.Blue};
    `,

    Description: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        color: ${Colors.Blue};
    `,

    ReguaHorizontal: styled.img`
        display: block;
        width: 100%;
        max-width: 1280px;
        margin-top: 24px;

        @media screen and (max-width: 1230px) {
            max-width: 100%;
        }
    `,
};

const FourSession = () => {
    const history = useHistory();
    const isMax1100 = IsCustomMaxWidth(1100);
    return (
        <Styled.Container>
            <Styled.Tag>
                *Ministério da Cultura, Alura Start e Guaraná Antarctica apresentam: ALFABETIZAÇÃO INTEGRAL EM APOIO AO COMPROMISSO NACIONAL
                CRIANÇA ALFABETIZADA
            </Styled.Tag>
            <Styled.Row>
                <div >
                    <img
                        src={ImgCapa}
                        style={{ width: isMax1100 ? '320px' : '', height: '440px' }}
                        alt=""
                    />
                </div>
                <Styled.Column>
                    <div>
                        <Styled.Title style={{ fontWeight: 400 }}>MATERIAL GRATUITO</Styled.Title>
                        <Styled.Title>Alfabetizar: das definições às boas práticas</Styled.Title>
                    </div>
                    <Styled.Description
                        dangerouslySetInnerHTML={{
                            __html: `
                        Em 2024 a Cátedra Instituto Ayrton Senna de inovação em Avaliação Educacional ofertou o curso Alfabetização Integral. </br>
                        O curso foi pensado para apoiar a alfabetização das crianças brasileiras e contou com grandes nomes do cenário da educação, como Maria Helena Guimarães e Castro, 
                        Inês Miskalo, Roxane Rojo e Kátia Smole, entre outros.
                        </br></br>
                        Agora você tem a oportunidade de acessar os vídeos com os 10 temas fundamentais que foram trabalhados no curso.
                        
                        `,
                        }}
                    />
                    <Styled.RowButtons>
                        <StyledGlobal.ButtonOutline onClick={() => history.push('/biblioteca/item/alfabetizar-das-definicoes-as-boas-praticas')}>
                            <img src={ImgDown} alt="" /> Download do material
                        </StyledGlobal.ButtonOutline>
                        <StyledGlobal.ButtonBlue
                            style={{ width: '224px' }}
                            onClick={() => history.push('/ebooks/alfabetizacao-integral-da-teoria-a-pratica-az')}
                        >
                            Versão acessível <RiShareBoxLine />
                        </StyledGlobal.ButtonBlue>
                    </Styled.RowButtons>
                </Styled.Column>
            </Styled.Row>
            <Styled.ReguaHorizontal src={ImgReguaHorizontal} alt="" />
        </Styled.Container>
    );
};

export default FourSession;
